import React from 'react';
import SuperAnalytics from './SuperAnalytics';

/**
 * Branch-scoped "التحليل الشامل" — same UX as the super-admin one,
 * but the data is automatically pinned to the requesting admin's own branch
 * via the /api/analytics/branch/* endpoints.
 */
export default function BranchAnalytics() {
  return <SuperAnalytics branchScoped />;
}
